import { Button, Grid } from '@mui/material';
import React from 'react';
import FilterAltOutlinedIcon from '@mui/icons-material/FilterAltOutlined';
import { useFormContext } from 'react-hook-form';
import { customersApiKeyStore } from '../../../api/customers-api-key-store';
import { servicesApiKeyStore } from '../../../api/masters/services-api-key-store';
import { officeApiKeyStore } from '../../../api/office-api-key-store';
import { projectsApiKeyStore } from '../../../api/projects-api-key-store';
import { unitsApiKeyStore } from '../../../api/units-api-key-store';
import { workorderReportApiKeyStore } from '../../../api/workorder-report-api-key-store';
import { FormAutoCompleteSelectDynamic } from '../../../components/hook-form/form-autocomplete-select.dynamic.component';
import FormDateField, { DateFormat } from '../../../components/hook-form/form-date.field.component';

const AuditLogFilters = () => {
  const { setValue, getValues, watch } = useFormContext();
  const handleChange = (type: string) => {
    if (type == 'customer') {
      setValue('office', { officeID: '', officeName: '' });
      setValue('project', { projectID: '', projectName: '' });
      setValue('unit', { unitID: '', unitName: '' });
    }
    if (type == 'office') {
      setValue('project', { projectID: '', projectName: '' });
      setValue('unit', { unitID: '', unitName: '' });
    }
    if (type == 'project') {
      setValue('unit', { unitID: '', unitName: '' });
    }
  };

  const watchValues = watch();

  //   console.log(21, watchValues);

  return (
    <Grid container spacing={1}>
      <Grid item lg={12} sm={12} xl={12} xs={12}>
        <Grid container spacing={1}>
          <Grid item xl={3} lg={3} sm={4} xs={6}>
            <FormAutoCompleteSelectDynamic
              name="customer"
              label="Customer"
              onChange={() => handleChange('customer')}
              getQueryKeyConfig={() => customersApiKeyStore.getCustomers()}
              optionsValueKey="customerID"
              optionsLabelKey="customerName"
            />
          </Grid>
          <Grid item xl={3} lg={3} sm={4} xs={6}>
            <FormAutoCompleteSelectDynamic
              name="office"
              label="Offices"
              disabled={!getValues('customer')}
              watchKeys={['customer']}
              onChange={() => handleChange('office')}
              getQueryKeyConfig={(inputData: any) =>
                officeApiKeyStore.getCustomerOffices(inputData.customer?.customerID)
              }
              optionsValueKey="officeID"
              optionsLabelKey="officeName"
            />
          </Grid>
          <Grid item xl={3} lg={3} sm={4} xs={6}>
            <FormAutoCompleteSelectDynamic
              name="project"
              label="Projects"
              disabled={!getValues('office')?.officeID}
              watchKeys={['office']}
              onChange={() => handleChange('project')}
              getQueryKeyConfig={(inputData: any) => projectsApiKeyStore.getOfficeProjects(inputData.office?.officeID)}
              optionsValueKey="projectID"
              optionsLabelKey="projectName"
            />
          </Grid>
          <Grid item xl={3} lg={3} sm={4} xs={6}>
            <FormAutoCompleteSelectDynamic
              name="unit"
              label="Lot/Unit"
              disabled={!getValues('project')?.projectID}
              watchKeys={['project']}
              getQueryKeyConfig={(inputData: any) => unitsApiKeyStore.getProjectUnits(inputData.project?.projectID)}
              optionsValueKey="unitID"
              optionsLabelKey="unitName"
            />
          </Grid>
          <Grid item lg={3} sm={34} xl={4} xs={6}>
            <FormDateField label="From" name="fromDate" format={DateFormat.SIMPLE_DATE} />
          </Grid>
          <Grid item lg={3} sm={34} xl={4} xs={6}>
            <FormDateField
              label="To"
              name="toDate"
              dateLimits={{ minDateEnabled: true, minDateValue: 'fromDate' }}
              format={DateFormat.SIMPLE_DATE}
            />
          </Grid>

          <Grid item xl={1.2} lg={1.2} sm={4} xs={6}>
            <Button type="submit" title="Filter" variant="contained" startIcon={<FilterAltOutlinedIcon />}>
              Filter
            </Button>
          </Grid>

          {/* <Grid item xl={1.8} lg={1.8} sm={6} xs={6}>
            <FormAutoCompleteSelectDynamic
              name="dateCriteria"
              label="Date Criteria"
              onChange={handleStatusChange}
              getQueryKeyConfig={() => workorderReportApiKeyStore.getWorkOrderReportDateCriteria()}
              optionsValueKey="dateCriteriaValue"
              optionsLabelKey="dateCriteria"
            />
          </Grid>
          <Grid item xl={1.5} lg={1.5} sm={4} xs={6}>
            <FormDateField
              label={fromDateName ? fromDateName : 'Date From'}
              name="fromDate"
              onChange={handleFromDate}
              disabled={!disabledFromData}
              format={DateFormat.SIMPLE_DATE}
            />
          </Grid>
          <Grid item xl={1.5} lg={1.5} sm={4} xs={6}>
            <FormDateField
              label={toDateName ? toDateName : 'Date To'}
              name="toDate"
              disabled={!disabledToDate}
              format={DateFormat.SIMPLE_DATE}
              dateLimits={{ minDateEnabled: true, minDateValue: 'fromDate' }}
            />
          </Grid> */}
        </Grid>
      </Grid>
    </Grid>
  );
};

export default AuditLogFilters;
